import React from 'react';
import './VideoLibrary.css';

function VideoLibrary() {
  return (
    <div className="video-library-container">
      <div className="video-library-heading">
        <h1>Video Library</h1>
      </div>
      <div className="video-library-center">
        <iframe
          className="iframe"
          src="https://www.youtube.com/embed/videoseries?list=PLPIuYXaGFn2pdzN_ED9FGUf0YVaEMrjqN"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  );
}

export default VideoLibrary;
